export default __webpack_public_path__ + "static/klawiatura-74d879d60a573d082858e366178343b0.webp";